import React, { createContext, useContext, useEffect, useState } from "react";
import api from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined=loading, null=guest, obj=user
  const [token, setToken] = useState(() => localStorage.getItem("pi_token") || null);

  useEffect(() => {
    let cancelled = false;
    async function check() {
      if (!token) {
        setUser(null);
        return;
      }
      try {
        const { data } = await api.get("/auth/me");
        if (!cancelled) setUser(data);
      } catch {
        if (!cancelled) {
          localStorage.removeItem("pi_token");
          setToken(null);
          setUser(null);
        }
      }
    }
    check();
    return () => { cancelled = true; };
  }, [token]);

  async function login(email, password) {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("pi_token", data.access_token);
    setToken(data.access_token);
    setUser(data.user);
    return data;
  }

  async function logout() {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("pi_token");
    setToken(null);
    setUser(null);
  }

  return (
    <AuthContext.Provider value={{ user, token, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
